import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import TransiluminatorSwitchOff from '@common/images/transiluminator-switch-off.svg';
import TransiluminatorSwitchOn from '@common/images/transiluminator-switch-on.svg';

export function Switch(props) {
  const switchImage = props.switchedOn
    ? TransiluminatorSwitchOn
    : TransiluminatorSwitchOff;

  return (
    <Image
      onClick={props.onClick}
      src={switchImage}
      style={props.style}
      alt='transiluminator-switch'
    />
  );
}

Switch.propTypes = {
  /**
   * style to set on component
   */
  style: PropTypes.object,
  /**
   * Boolean specifying if Apparatus is ON/OFF
   */
  switchedOn: PropTypes.bool,
  /**
   * Callback function to invoke when SwichIsClicked
   */
  onClick: PropTypes.func,
};
